import {
  Configuration,
  PonyfillFactoryCredentials,
  AddressData,
  AgentData,
  ChatbotData,
  UserData,
  characters,
  CustomVoice,
  // @ts-ignore
} from "@davi/retorik-framework";
import { botEventHandler } from "../components/BotEventHandler";
import { generateUsername } from "../utils/globalUtils";

const config: Configuration = {
  locales: {
    default: "fr-FR",
    // others: ['fr-FR', 'de-DE', 'en-US', 'es-ES']
  },
  position: {
    testFromBrowser: false,
  },
  mainframe: {
    background: {
      image: "images/background_enseignant.jpg",
      video: "videos/Varkala_Beach.webm",
      neutral: "#a86232",
    },
    chosenBackground: "image",
  },
  logo: {
    src: "images/logo.png",
  },
  subtitles: {
    activated: true,
    maxLength: 50,
    showAttachmentsAsSubtitle: false,
  },
  menu: {
    mainMenu: ["micro", "keyboard", "|", "subtitles", "history"],
    subMenu: [],
  },
  answerpanel: true,
  //tutorialButton: true,
  skipWelcome: true,
  screenSaver: {
    implemented: false,
    image: "images/save_screen.jpg",
    timeout: 60,
  },
};

const agentData = "/videos/enseignant_smile";
//const agentData = characters.lea

const chatbotData: ChatbotData = {
  size: undefined,
  height: undefined,
};

let randomUsername = generateUsername();
const userData: UserData = {
  name: randomUsername,
  id: randomUsername,
  username: randomUsername,
  nom: "RETORIK",
  prenom: "Davi",
  email: "davi@davi.ai",
  token: "",
  referrer: "",
  ipaddress: "",
};

const ponyfillFactoryCredentials: PonyfillFactoryCredentials = {
  region: "WestEurope",
  subscriptionKey: "e0f01db580ec41a29ff0e0fa53e97e60",
};

const addressData: AddressData = {
  baseURI: "studio.retorik.ai/CHU_BordeauxV2/K2.ContentFields.WebChat",
  //baseURI: 'localhost:5001/K2.ContentFields.WebChat',
  tenant: "",
  prefix: "",
};

const customVoice: CustomVoice = {
  gender: "male",
};

export type RetorikConfiguration = {
  config: Configuration;
  chatbotData: ChatbotData;
  agentData: string;
  ponyfillFactoryCredentials: PonyfillFactoryCredentials;
  addressData: AddressData;
  userData: UserData;
  externalEventHandler?: Function;
  customVoice: CustomVoice;
};

export const BaseRetorikConfig: RetorikConfiguration = {
  config,
  chatbotData,
  addressData,
  userData,
  ponyfillFactoryCredentials,
  externalEventHandler: botEventHandler,
  agentData,
  customVoice,
};
